<template>
    <div>
        <validation-observer ref="" tag="form">
            <b-row>
                <b-col cols="12" class="mb-2">
                    <h5 class="mb-0">Resumen</h5>
                    <small class="text-muted">Review of the data of the day</small>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h1>Type visits</h1>
                    <vue-apex-charts type="donut" height="300" :options="optionsTV" :series="seriesTV" />
                </b-col>
                <b-col>
                    <h1>Networks</h1>
                    <vue-apex-charts type="donut" height="300" :options="optionsR" :series="seriesR" />
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col cols="12">
                    <DayTotalsReference :dayTotals="dayTotals" :loading="dayTotalsLoading" />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5 class="mb-0">Closing reference</h5>
                    <small class="text-muted d-block mb-2">
                        Visit count and clinic income for this closing. This is not the amount to match against cash in the drawer.
                    </small>
                    <b-table stacked :fields="referenceFields" :items="referenceItems" show-empty empty-text="No data loaded">
                        <template #cell(total_patients)>
                            {{ totalPatients }}
                        </template>
                        <template #cell(total_income)>
                            $ {{ income }}
                        </template>
                    </b-table>
                    <h5 class="mb-0 mt-4">Cash count (drawer)</h5>
                    <small class="text-muted d-block mb-2">
                        Amount to match against cash in the drawer.
                    </small>
                    <b-table stacked :fields="drawerFields" :items="drawerItems" show-empty empty-text="No cash data loaded">
                        <template #cell(total_cash)>
                            $ {{ current_balance }}
                        </template>
                    </b-table>
                </b-col>
                <b-col>
                    <b-form-group label="Observation" label-for="observatiom">
                        <validation-provider #default="{ errors }" name="Observation" rules="required">
                            <textarea name="observatiom" id="observatiom" class="form-control"
                                v-model="cashClosing.observation" :state="errors.length > 0 ? false : null"></textarea>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DayTotalsReference from "./DayTotalsReference.vue";
import { summarizeCashClosingCharts } from "@/core/utils/typeVisitsChart";

export default {
    components: {
        VueApexCharts,
        ValidationProvider,
        ValidationObserver,
        DayTotalsReference,
    },
    props: {
        dailyData: {
            type: Object,
            default: () => { },
            required: false
        },
        cashClosing: {
            type: Object,
            default: () => { },
            required: false
        },
        dayTotals: {
            type: Object,
            default: null,
        },
        dayTotalsLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        current_balance() {
            return (this.dailyData && this.dailyData.current_balance) || 0
        },
        income() {
            return (this.dailyData && this.dailyData.income) || 0
        },
        chartSummary() {
            const cashes = (this.dailyData && this.dailyData.cashes) || []
            return summarizeCashClosingCharts(cashes)
        },
        totalPatients() {
            return this.chartSummary.totalPatients
        },
        referenceItems() {
            if (!this.dailyData) return []
            return [{
                total_patients: this.totalPatients,
                total_income: this.income,
            }]
        },
        drawerItems() {
            if (!this.dailyData) return []
            return [{
                total_cash: this.current_balance,
            }]
        },
    },
    watch: {
        dailyData: {
            immediate: true,
            handler() {
                this.buildCharts()
            },
        },
    },
    data() {
        return {
            optionsTV: {
                labels: ['F/U: 0', 'N/C: 0', 'N/P: 0', 'P/I: 0', 'P/P: 0', 'R/S: 0', 'V/C: 0', 'M/B: 0', 'N/A: 0'],
                dataLabels: {
                    enabled: true
                }
            },
            optionsR: {
                labels: ['Radio: 0', 'TV: 0', 'Facebook: 0', 'Reference: 0', 'Sign: 0', 'Flyers: 0', 'Internet: 0', 'Others: 0'],
                dataLabels: {
                    enabled: true
                }
            },
            referenceFields: [
                { key: 'total_patients', label: 'Total patients' },
                { key: 'total_income', label: 'Clinic daily income' },
            ],
            drawerFields: [
                { key: 'total_cash', label: 'Total cash' },
            ],
            seriesTV: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            seriesR: [0, 0, 0, 0, 0, 0, 0, 0],
        }
    },
    methods: {
        buildCharts() {
            const summary = this.chartSummary
            this.seriesTV = summary.seriesTV
            this.seriesR = summary.seriesR
            this.optionsTV = {
                ...this.optionsTV,
                labels: summary.labelsTV,
            }
            this.optionsR = {
                ...this.optionsR,
                labels: summary.labelsR,
            }
        },
    },
}
</script>

<style></style>
